import ScrollVelocity from '../Reactbits/ScrollVelocity/ScrollVelocity';

const stylecss = {
    marginTop : "120px",
   
}
function Motiontext() {
  return (

  
  <div className="motion-div" style={stylecss}>
    <ScrollVelocity
  texts={['My Portfolio-Exprience-Services', 'Scroll Down']} 
  className="custom-scroll-text"
/>
  </div>
  )
}

export default Motiontext
